// extracted by mini-css-extract-plugin
module.exports = {"popup-box":"_1F5tc6HTxp3PcKVRFSoPiv"};